import { createContext, useContext, useState, useEffect } from 'react';
import { fetchFaqPageData } from './pageDataService';

const FaqDataContext = createContext(null);

export const FaqDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_faq_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchFaqPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_faq_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache faq data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <FaqDataContext.Provider value={{ data, isLoading }}>
      {children}
    </FaqDataContext.Provider>
  );
};

export const useFaqData = () => {
  const context = useContext(FaqDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
